import { ScrollArea } from "@components/ui/scroll-area";
import { FormControl, FormField, FormItem, FormMessage } from "@shared-kernel/primary/shared/shadcn/ui/form";
import { Label } from "@shared-kernel/primary/shared/shadcn/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@shared-kernel/primary/shared/shadcn/ui/select";
import { formatPostalAddress } from "@shared-kernel/domain/types/postal-address";
import type { PublicStudioListVM } from "@shared-kernel/application/ports/public/public-repository";

interface StudioTypeSelectorProps {
  studios: PublicStudioListVM[];
}

export const StudioTypeSelector = ({ studios }: StudioTypeSelectorProps) => {
  return (
    <div className="space-y-4">
      <FormField
        name="studio.studioId"
        render={({ field }) => (
          <FormItem>
            <Label className="font-medium">Choisissez votre studio partenaire *</Label>
            <Select onValueChange={field.onChange} defaultValue={field.value ?? undefined}>
              <FormControl>
                <SelectTrigger className="h-12 bg-background" onClick={e => e.stopPropagation()}>
                  <SelectValue placeholder="Sélectionnez un studio partenaire" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                <ScrollArea className="h-[315px]">
                  {studios.map(studio => (
                    <SelectItem key={studio.id} value={studio.id}>
                      <div className="flex flex-col items-start">
                        <span className="font-medium text-foreground">{studio.name}</span>
                        <span className="text-sm text-muted-foreground">{formatPostalAddress(studio.postalAddress)}</span>
                      </div>
                    </SelectItem>
                  ))}
                </ScrollArea>
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />
      <p className="text-xs italic text-muted-foreground">
        Si vous ne trouvez pas votre studio, cliquez sur &quot;Autre Studio&quot; ci-dessous
      </p>
    </div>
  );
};
